import * as React from 'react';
import { memo } from 'react';
import { Helmet } from 'react-helmet';
import { MdChevronRight } from 'react-icons/md';
import LayoutV3 from '../components/LayoutV3';
import CtaButton from './components/CtaButton';
import Hero1 from './components/Hero1';
import Hero2 from './components/Hero2';
import { Label, Label4, Label5 } from './consts';
import './landing.scss';
import { Link } from 'gatsby';
import classNames from 'classnames';

function LandingPage() {
  return (
    <LayoutV3>
      <Helmet>
        <title>Introducing CyrenCare</title>
        <meta
          name='description'
          content='Crowded ERs, burned out staff, patients leaving before treatment is completed, billing denials due to incorrect or incomplete documentation. Your ED is losing revenue between your fingers. Let’s see how CyrenCare can help reclaim that.'
        />
      </Helmet>

      <div className='h-0 md:h-10'></div>

      <div className='landing-page landingV3'>
        <Hero1 />

        <div className='h-10'></div>
        <div className='h-10'></div>

        <div className='container mx-auto gap-0'>
          <Hero2 />

          <div className='h-10' />
        </div>

        {/* FORM */}
        <div className='hero1 mx-auto bg-light2 py-20 md:p-32'>
          <div className='flex-col flex-1 px-4 md:px-32 gap-14'>
            <div className='title flex-center text-center'>
              {Label.label4}
              <br />
              {Label.label5}
            </div>

            <div className='flex-1 flex gap-12 flex-center'>
              <div className='flex-col md:flex md:flex-row gap-20 text-center'>
                {Label4.map((item) => {
                  return (
                    <div key={item.title} className='flex-1 flex-col gap-4 min-w-[17rem]'>
                      <div className='h-32 flex-center'>
                        <img src={item.img} className='h-full' />
                      </div>
                      <div className='flex-col gap-3'>
                        <div className='font-semibold text-xl'>{item.title}</div>
                        <div className='flex-center'>
                          <div className='px-5 py-2 bg-[#6356FE1A] rounded-full text-[#6356FE]'>
                            {item.subtitle}
                          </div>
                        </div>
                        <div className='flex-center py-5'>
                          
                          <Link
                            to={item.to}
                            activeClassName="btn-active"
                            className={classNames('btn btn-ghost tBase btn-lg')}
                            onClick={() => {}}
                          >
                            {item.ctaLabel}
                            <MdChevronRight size={24} className='opacity-60' />
                          </Link>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
          <div className='flex-center pt-20'>
            <CtaButton />
          </div>
        </div>

        <div className='hero1 mx-auto py-20 md:p-32'>
          <div className='flex-1 flex gap-12 flex-center'>
            <div className='flex-col md:flex md:flex-row gap-20 text-center'>
              {Label5.map((item) => {
                return (
                  <div key={item.title} className='flex-1 flex-col gap-4 min-w-[17rem]'>
                    <div className='flex-center pb-6'>
                      <img src={item.img} className='w-64' />
                    </div>
                    <div className='flex-col gap-3 px-5 md:px-14'>
                      <div className='font-semibold text-2xl'>{item.title}</div>
                      <div className='flex-center'>
                        <div className='opacity-70'>{item.subtitle}</div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        <div className='h-20' />
      </div>
    </LayoutV3>
  );
}

export default memo(LandingPage);
